<!-- <sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle='Add new' [showBackButton]="false">
  <ng-template #addButton>
    <div class="d-flex search-field">
      <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent">
      <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
    </button>
    </div>
  </ng-template>
</sm-misc-title-bar> -->

<sm-title-bar pageTitle="New promotion" [backWithParams]="true"> </sm-title-bar>

<div>
  <mat-form-field appearance="outline">
    <mat-label>Title</mat-label>
    <input [(ngModel)]="promotionData.title" matInput #input />
  </mat-form-field>
</div>
<div>
  <mat-form-field appearance="outline">
    <mat-label>Description</mat-label>
    <textarea [(ngModel)]="promotionData.body" matInput></textarea>
  </mat-form-field>
</div>

<div>
  <mat-form-field appearance="outline">
    <mat-label>External link</mat-label>
    <input [(ngModel)]="promotionData.external_link" matInput #input />
  </mat-form-field>
</div>
<!-- <div>
        <mat-form-field appearance="outline">
          <mat-label>Campaign cost</mat-label>
          <input
          smDecimalOnly type="number"
          [(ngModel)]="promotionData.campaign_cost"
            matInput
            #input
          />
          
        </mat-form-field>
      </div> -->
<div class="chip_memberder">
  <div class="target_headingt">
    <h3>Targets</h3>
  </div>
  <mat-chip-listbox aria-label="Fish selection">
    <mat-chip
        [ngClass]="{ selected: selectedValue == '1' }"
        (click)="changeChip('1')"
      >
        All customers</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '2' }"
        (click)="changeChip('2')"
        >All enrolled members</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '5' }"
        (click)="changeChip('5')"
        >All membership request</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '7' }"
        (click)="changeChip('7')"
        >All service queries</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '3' }"
        (click)="changeChip('3')"
        >Selected customers</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '4' }"
        (click)="changeChip('4')"
        >Selected enrolled members</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '6' }"
        (click)="changeChip('6')"
        >Selected membership request</mat-chip
      >
      <mat-chip
        [ngClass]="{ selected: selectedValue == '8' }"
        (click)="changeChip('8')"
        >Selected service query</mat-chip
      >
  </mat-chip-listbox>
</div>

<div class="target_hesdingh">
  <p>
    Target selected:
    {{
        promotionData.all_customers == 1
          ? selectedValue == "1"
            ? "All customers"
            : selectedValue == "2"
            ? "All enrolled members"
            : selectedValue == "5"
            ? "All membership request"
            : selectedValue == "7"
            ? "All service queries"
            : ""
          : promotionData.targetArr.length +
            (selectedValue == "3"
              ? " customers"
              : selectedValue == "4"
              ? " enrolled members"
              : selectedValue == "6"
              ? " membership requests"
              : selectedValue == "8"
              ? " service queries"
              : "")
      }}
  </p>
</div>

<div>
  <p style="color: rgba(0, 0, 0, 0.6)">Campaign type:</p>
</div>
<div
  class="add_crt"
  style="display: flex; margin-bottom: 20px; margin-top: 15px"
>
  <div class="try">
    <mat-checkbox
      [(ngModel)]="promotionChecks.whatsapp"
      (change)="updatePromotionType()"
    ></mat-checkbox>
    <label for="testing1" class="check-label">WhatsApp</label>
  </div>
  <div class="try">
    <mat-checkbox
      [(ngModel)]="promotionChecks.email"
      (change)="updatePromotionType()"
    ></mat-checkbox>

    <label for="testing1" class="check-label">E-mail</label>
  </div>
  <div class="try">
    <mat-checkbox
      [(ngModel)]="promotionChecks.sms"
      (change)="updatePromotionType()"
    ></mat-checkbox>

    <label for="testing1" class="check-label">SMS</label>
  </div>
</div>

<div class="campaing_datex">
  <div class="row">
    <div class="col-sm-6">
      <div class="nw_all">
        <mat-form-field appearance="outline">
          <mat-label>Campaign start</mat-label>
          <input
            matInput
            [matDatepicker]="fromDatePicker"
            readonly
            [(ngModel)]="promotionData.campaign_start_date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #fromDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="nw_all">
        <mat-form-field appearance="outline">
          <mat-label>Campaign end</mat-label>
          <input
            matInput
            [matDatepicker]="toDatePicker"
            readonly
            [(ngModel)]="promotionData.campaign_end_date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #toDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div style="display: flex; justify-content: center; align-items: center">
  <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
</div>
<div
  class="image-preview"
  *ngIf="assetList.length > 0"
  style="
    position: relative;
    width: fit-content;
    margin-bottom: 20px;
    border: 1px solid lightgray;
    padding: 15px;
  "
>
  <img
    [src]="assetList[0].url"
    alt=""
    style="width: 200px; height: 170px; object-fit: cover"
  />
  <span
    (click)="removeAsset()"
    style="
      position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background: #dd2c00;
      border-radius: 50%;
      height: 30px;
      width: 30px;
    "
    ><mat-icon
      style="position: absolute; left: 3px; top: 2px; color: white"
      class="material-icons-outlined"
      >close</mat-icon
    ></span
  >
</div>
<div class="upload-group mb-2">
  <label for="formFile" class="form-label">Upload media</label>
  <div class="file-input-wrap">
    <div class="custom-input-label">
      <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
        >backup</mat-icon
      >
      <p>Drop your file(s) here or <span>browse</span></p>
    </div>
    <input
      class="form-control"
      id="formFile"
      accept="image/*"
      type="file"
      multiple
      (change)="onUploadImage($event)"
    />
  </div>
  <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
</div>

<mat-dialog-actions align="end" class="fill_btrt">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    [disabled]="
      !promotionData.title ||
      !promotionData.body ||
      !promotionData.campaign_start_date ||
      !promotionData.campaign_end_date || promotionData.promotion_type == 0 ||
      ((selectedValue == '3' || selectedValue == '4') &&
        promotionData.targetArr.length == 0)
    "
    (click)="confirm()"
    mat-flat-button
    color="accent"
  >
    Confirm
  </button>
</mat-dialog-actions>

<!-- <mat-dialog-content>
    <div class="row">
        <div class="col-sm-12">
            <div class="fl_orders">
                <div class="top_section_order">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="ads_sec">
                                <div class="hm_icon_progr">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-10">
                            <div class="order_dec">
                                <div class="tick_opklads">
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon>
                                </div>
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;">Suraj Paul</h3>
                                <p>+91 9289893444</p>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="col-sm-12">
            <div class="fl_orders">
                <div class="top_section_order">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="ads_sec">
                                <div class="hm_icon_progr">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-10">
                            <div class="order_dec">
                                <div class="tick_opklads">
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon>
                                </div>
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;">Suraj Paul</h3>
                                <p>+91 9289893444</p>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="col-sm-12">
            <div class="fl_orders">
                <div class="top_section_order">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="ads_sec">
                                <div class="hm_icon_progr">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-10">
                            <div class="order_dec">
                                <div class="tick_opklads">
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon>
                                </div>
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;">Suraj Paul</h3>
                                <p>+91 9289893444</p>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </mat-dialog-content> -->

<!--   
  <div class="placeholder-modal">
  <div class="placeholder-container">
    <div class="icon-box">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M256 207c47.972 0 87-39.028 87-87s-39.028-87-87-87-87 39.028-87 87 39.028 87 87 87zm0-144c31.43 0 57 25.57 57 57s-25.57 57-57 57-57-25.57-57-57 25.57-57 57-57zM432 207c30.327 0 55-24.673 55-55s-24.673-55-55-55-55 24.673-55 55 24.673 55 55 55zm0-80c13.785 0 25 11.215 25 25s-11.215 25-25 25-25-11.215-25-25 11.215-25 25-25zM444.1 241h-23.2c-27.339 0-50.939 16.152-61.693 39.352C337.066 256.182 305.263 241 269.979 241h-27.957c-35.284 0-67.087 15.182-89.228 39.352C142.039 257.152 118.439 241 91.1 241H67.9C30.46 241 0 271.276 0 308.49V417.7C0 433.856 13.194 447 29.412 447h91.727c1.538 17.9 16.59 32 34.883 32h199.957c18.292 0 33.344-14.1 34.883-32h90.679c16.796 0 30.46-13.61 30.46-30.34V308.49C512 271.276 481.54 241 444.1 241zM30 308.49C30 287.818 47.002 271 67.9 271h23.2c20.898 0 37.9 16.818 37.9 37.49v10.271c-10.087 26.264-8 42.004-8 98.239H30zm331 135.489a5.026 5.026 0 0 1-5.021 5.021H156.021a5.027 5.027 0 0 1-5.021-5.021v-81.957c0-50.19 40.832-91.022 91.021-91.022h27.957c50.19 0 91.022 40.832 91.022 91.021zm121-27.319c0 .517 5.592.34-91 .34 0-56.651 2.071-72.018-8-98.239V308.49c0-20.672 17.002-37.49 37.9-37.49h23.2c20.898 0 37.9 16.818 37.9 37.49zM80 207c30.327 0 55-24.673 55-55s-24.673-55-55-55-55 24.673-55 55 24.673 55 55 55zm0-80c13.785 0 25 11.215 25 25s-11.215 25-25 25-25-11.215-25-25 11.215-25 25-25z" fill="#878787" opacity="1" data-original="#000000"></path></g></svg>
    </div>
    <h2>No customer to select here.</h2>
    <p>
      It seems like you haven’t started operations yet.<br />
      There’s no customer to show here. Go to Customers section and check for once.
    </p>
  </div>
</div> -->

<!-- <mat-dialog-actions align="end">
    <button mat-button>Back</button>
    <button
      mat-flat-button
      color="accent">
    Confirm
    </button>
  </mat-dialog-actions> -->
